import {createSlice} from '@reduxjs/toolkit';

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isLogin: JSON.parse(localStorage.getItem('is_login')) || false,
        profile: {},
    },
    reducers: {
        loginUser: (state,action) => {
            localStorage.setItem('is_login', 'true');
            localStorage.setItem('access_token', action.payload.access_token);
            localStorage.setItem('refresh_token', action.payload.refresh_token);
            state.isLogin = true;
        },
        logoutUser: (state) => {
            localStorage.setItem('is_login', 'false');
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            state.isLogin = false;
        },
        getUserProfile: (state, action) => {
            state.profile = action.payload;
        },
    }
});

export const {loginUser, logoutUser, getUserProfile} = authSlice.actions;
export default authSlice.reducer;